import React, { useEffect } from 'react';
import { Input } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../Context';
import { VoucherFormSection } from '../Section';
import { Asterisk } from '../Asterisk';

const MaxUsageCount = () => {
  const {
    formState: {
      payload: { maxUsageCount },
    },
    setFormState,
    setFormError,
    formErrors,
  } = useVoucherFormContext();

  useEffect(() => {
    return () => setFormError('maxUsageCount', null);
  }, [setFormError]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parsed = parseInt(value, 10);
    const isValid = !isNaN(parsed) && parsed >= 1;

    setFormState(prev => ({
      ...prev,
      payload: {
        ...prev.payload,
        maxUsageCount: isValid ? parsed : undefined,
      },
    }));

    setFormError('maxUsageCount', isValid ? null : 'Maximum usage count is required');
  };

  const error = formErrors.maxUsageCount;

  return (
    <VoucherFormSection
      title='Maximum usage count'
      subtitle='How many times the campaign code can be redeemed in total.'
      inputs={
        <Input
          name='max-usage-count'
          id='max-usage-count'
          label={
            <>
              Maximum usage count <Asterisk />
            </>
          }
          type='number'
          required
          min={1}
          value={maxUsageCount !== undefined ? String(maxUsageCount) : ''}
          valid={error ? false : undefined}
          infoError={error}
          onChange={handleChange}
        />
      }
    />
  );
};

export default MaxUsageCount;
